<template>
  <b-modal id="editar-marca" :title="$t('vMarca.editarMarca')" centered hide-footer ref="modalEditarMarca"
    @hidden="resetModal" size="lg">
    <b-form @submit.stop.prevent="createMarca">
      <p class="text-danger" v-if="existeNombre">
        El nombre ingresado ya está en uso. Por favor, ingrese un nombre
        diferente.
      </p>
      <div class="row">
        <b-col cols="12" sm="12">
          <label for="“nombre”">{{ $t("vMarca.marca") }}* :</label>
          <b-form-input id="input-nombre" v-model="datosMarca.nombre" :state="estatus"
            aria-describedby="input-nombre-help input-nombre-feedback" trim>
          </b-form-input>
          <b-form-invalid-feedback id="input-nombre-feedback">
            {{ $t("vMarca.msgMarca") }}
          </b-form-invalid-feedback>
        </b-col>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
          <b-btn color="primary" class="ancho-boton w-100" style="color: white" @click="$bvModal.hide('editar-marca')">
            {{ this.$t("Gral.cancelar") }}
          </b-btn>
        </div>
        <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
          <b-btn variant="info" class="ancho-boton w-100" style="color: white" type="submit"
            :disabled="estatus === null || estatus === false">
            {{ $t("vMarca.agregarMarca") }}
          </b-btn>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import { generalSweetAlert } from "../../../utils/Utils";

export default {
  props: {
    datosMarca: {
      type: Object,
      default: () => ({ id: null, nombre: "", habilitado: null }),
    },
  },
  data() {
    return {
      existeNombre: false,
      estatus: null,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: sessionStorage.getItem('key')
    };
  },
  watch: {
    "datosMarca.nombre"(data) {
      this.validarNombreMarca(data);
    },
  },
  methods: {
    validarNombreMarca(nombre) {
      if (!nombre || nombre.trim() === "") {
        this.estatus = null;
        return;
      }

      this.estatus = nombre.trim().length >= 4;
    },

    showModal() {
      this.$refs.modalEditarMarca.show();
    },

    resetModal() {
      this.existeNombre = false;
    },

    async createMarca() {
      try {
        const data = {
          id: this.datosMarca.id,
          marca: this.datosMarca.nombre,
          habilitado: this.datosMarca.habilitado,
        };

        const response = await MarcasDataService.update(data, this.key);
        if (response.status === 200) {
          this.$emit("actualizarTabla", response.status);
          this.accion = "Actualizó la marca " + data.marca;
          this.$refs.modalEditarMarca.hide();
          this.registrarAccion();

          generalSweetAlert(this.$t('vMarca.msgActualizar'), 'success')
        }
      } catch (error) {
        if (error.response.status === 406) {
          this.existeNombre = true;
          this.estatus = false;
        }

        generalSweetAlert(this.$t('vMarca.msgErrorActualizarMarca'), 'error')
      }
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    }
  },
};
</script>

<style>
@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px
  }
}
</style>